import script from "./IssueSamplingPoint.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueSamplingPoint.view.vue?vue&type=script&lang=ts&setup=true"

import "./IssueSamplingPoint.view.vue?vue&type=style&index=0&id=cba49e92&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba49e92"]])

export default __exports__